const steps = [
  {
    number: '1',
    title: 'お問い合わせ',
    description: 'こちらからまずはお気軽にお問い合わせください。少し興味がある程度でも構いません。',
  },
  {
    number: '2',
    title: 'ヒアリング',
    description: 'お客様のビジネス状況や課題、必要なマッチング相手をヒアリングいたします。',
  },
  {
    number: '3',
    title: '提案',
    description: 'お客様のニーズに合わせたマッチング支援をご提案いたします。',
  },
];

const ConsultationSection = () => {
  return (
    <section id="consultation" className="py-20 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <div className="w-full h-[300px] md:h-[360px] rounded-lg overflow-hidden">
            <img
              src="https://public.readdy.ai/ai/img_res/ee0c45440b95c1fa8e8e38caa7816aee.jpg"
              alt="無料相談"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div>
            <p className="text-[#3d6b4f] text-xs font-semibold tracking-widest uppercase mb-3">Free Consultation</p>
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-8">無料相談のご案内</h2>
            <div className="flex flex-col gap-6">
              {steps.map((step) => (
                <div key={step.number} className="flex gap-4 items-start">
                  <div className="flex-shrink-0 w-8 h-8 flex items-center justify-center bg-[#3d6b4f] text-white text-xs font-bold rounded-full">
                    {step.number}
                  </div>
                  <div>
                    <h3 className="text-sm font-bold text-gray-900 mb-1">{step.title}</h3>
                    <p className="text-xs text-gray-500 leading-relaxed">{step.description}</p>
                  </div>
                </div>
              ))}
            </div>
            <a
              href="#contact"
              className="inline-block mt-8 bg-[#3d6b4f] hover:bg-[#2f5540] text-white text-sm font-semibold px-7 py-3 rounded-md transition-colors cursor-pointer whitespace-nowrap"
            >
              無料相談はこちら
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ConsultationSection;
